<template>
  <div id="login">
    <b-container v-if="show" class="mt-5">
      <b-row lass="justify-content-md-center text-center">
        <b-col sm="12">
          <Notification :message="errorM" v-if="errorM" />
        </b-col>
      </b-row>
      <b-row class="justify-content-md-center">
        <b-col sm="5 my-3 p-3 bg-white rounded shadow-sm">
          <h4>Ingresar</h4>
          <hr>
          <b-form @submit="ingresar($event)">
            <b-form-group label="Correo electrónico:">
              <b-form-input
                v-model="form.email"
                type="email"
                required
                placeholder="Ingresa tu correo electrónico"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Contraseña:">
              <b-form-input
                v-model="form.password"
                required
                type="password"
                placeholder="Ingresa tu contraseña"
                minlength="6"
              ></b-form-input>
            </b-form-group>
            <b-button type="submit" block class="boton_createch p-2">Entrar</b-button>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import axios from "axios";
import Notification from "../components/Login/Notification";
export default {
  components: {
    Notification
  },
  data() {
    return {
      form: {
        email: "",
        password: ""
      },
      errorM: null,
      show: true
    };
  },
  methods: {
    ingresar(event) {
      event.preventDefault();
      axios
        .post("login", this.form)
        .then(res => { 
          if (res.status === 202) {
            this.makeToast("Contraseña erronea.", "Log In.");
          } else if (res.status === 220) {
            this.makeToast("Cuenta de correo no registrada.", "Log In.");
          } else {
            console.log(res.data.token);
            this.$store.dispatch("guardarToken", res.data.token);
            this.$router.push({ name: "home" });
            return res.data;
          }
        })
        .catch(error => {
          console.log(error);
          this.errorM = "Ocurrió un error inesperado.";
          this.makeToast("Ocurrió un error inesperado.", "Log In.");
        });
    }
  }
};
</script>
